module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-1.572c6a1a.png";